export default {"src":"/_next/static/media/placeholder.0fb6d5bd.svg","height":611,"width":611,"blurWidth":0,"blurHeight":0};